import { Box, Card, CardContent, Divider } from '@mui/material'
import HistoryItemField from '@component/HistoryItemField'
import { LooksTwoRounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { BeamInput } from '@core/const'

export interface BeamHistory extends BeamInput {
  type: 'Beam',
  result: number
}

interface Props {
  history: BeamHistory
}
function BeamHistoryItem ({ history }: Props) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent className="flex gap-16 !py-8">
        <LooksTwoRounded />
        <Box className="grid grid-cols-2 gap-8 min-w-[16rem] overflow-auto">
          <HistoryItemField
            label={t('GLOSSARY.REBAR_STRENGTH')}
            unit="MPa"
            value={history.rebarStrength}
          />
          <HistoryItemField
            label={t('GLOSSARY.BEAM_SPAN')}
            unit="m"
            value={history.beamSpan}
          />
        </Box>
        <Box>
          <Divider orientation="vertical" />
        </Box>
        <HistoryItemField
          label={t('GLOSSARY.MIN_REQUIRED_DEPTH')}
          unit="mm"
          value={history.result.toFixed(0)}
        />
      </CardContent>
    </Card>
  )
}

export default BeamHistoryItem
